import { PASSWORD_MIN_LENGTH } from '@chukua/common';
import { Alert, Button, Form, Input } from 'antd';
import { Lock } from 'lucide-react';

interface LoginNewPasswordFormProps {
  error: string | null;
  submitting: boolean;
  onSubmit: (password: string) => void;
}

export function LoginNewPasswordForm({ error, submitting, onSubmit }: LoginNewPasswordFormProps) {
  return (
    <>
      <h1 className="text-2xl font-semibold tracking-tight text-fg">Set a new password</h1>
      <p className="mt-1.5 mb-8 text-sm text-muted">Your password was reset by an admin. Choose a new one to continue.</p>
      {error && <Alert className="mb-5" type="error" title={error} showIcon />}
      <Form<{ password: string }> layout="vertical" size="large" requiredMark={false} onFinish={(values) => onSubmit(values.password)} disabled={submitting}>
        <Form.Item
          name="password"
          label="New password"
          rules={[{ required: true, min: PASSWORD_MIN_LENGTH, message: `Password must be at least ${PASSWORD_MIN_LENGTH} characters` }]}
        >
          <Input.Password prefix={<Lock className="size-4 text-muted" />} autoComplete="new-password" autoFocus />
        </Form.Item>
        <Form.Item className="mb-0 pt-2">
          <Button type="primary" htmlType="submit" block loading={submitting}>
            Set password
          </Button>
        </Form.Item>
      </Form>
    </>
  );
}
